var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticStyle:{"margin":"20px 0"}},[_c('div',{staticStyle:{"float":"left","text-align":"left"}},[_vm._t("left")],2),_c('div',{staticStyle:{"float":"right","text-align":"left"}},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }